import Axios from 'axios';
import ToastService from '../../service/toast/ToastService';

const mergeCommonHeaders = headers => {
  const authToken = localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)

  return authToken
    ? { ...headers, Authorization: `Bearer ${authToken}` }
    : headers
}

const AxiosClient = Axios.create({
  baseURL: process.env.REACT_APP_API,
})

const MiddlewareConfig = {
  returnRejectedPromiseOnError: true,
  interceptors: {
    request: [
      {
        success: function ({ getState, dispatch, getSourceAction }, request) {
          request.headers.common = mergeCommonHeaders(request.headers.common)
          return request
        },
        error: function ({ getState, dispatch, getSourceAction }, error) {
          return error
        }
      }
    ],
    response: [
      {
        success: function ({ getState, dispatch, getSourceAction }, req) {
          return req.data
        },
        error: function ({ getState, dispatch, getSourceAction }, error) {
          const response = error.response ? error.response.data : {}
          const messages = response.errorMessages
            ? response.errorMessages
            : ['Ocorreu um erro inesperado.']

          messages.forEach(message => ToastService.error(message))
          
          return Promise.reject(response)
        }
      }
    ]
  }
}

export const get = (url) => {
  return AxiosClient.get(url, {
    headers: mergeCommonHeaders({})
  }).then(x => x)
    .catch(x => {
      const response = x.response ? x.response.data : {}
      const message = response.errorMessage
        ? response.errorMessage
        : 'Ocorreu um erro inesperado.'
      ToastService.error(message)
    })
}

export default {
  AxiosClient,
  MiddlewareConfig,
  mergeCommonHeaders
}



// WEBPACK FOOTER //
// ./src/shared/infra/http/AxiosConfig.js